import { useWishlist } from "./WishlistStore";

export function WishlistEntry({ onOpen }: { onOpen: () => void }) {
  const { total } = useWishlist();
  return <button className="wishlist-entry" type="button" onClick={onOpen} aria-label={`打开心愿单，共 ${total} 款`}><span aria-hidden="true">♡</span> 心愿单{total ? <b>{total > 99 ? "99+" : total}</b> : null}</button>;
}
